import { func, object, shape } from "prop-types";

import RequirementsBadge from "./components/RequirementsBadge";

const TraceCell = ({ row, onTrace }) => {
  const { id, title, coveredPointIds } = row.original;
  const count = (coveredPointIds || []).length;

  if (count === 0) {
    return null;
  }

  return (
    <RequirementsBadge
      length={count}
      onClick={(event) => {
        event.stopPropagation();
        onTrace(id, event.currentTarget);
      }}
      title={title}
    />
  );
};

TraceCell.propTypes = {
  onTrace: func.isRequired,
  row: shape({ original: object }).isRequired,
};

export default TraceCell;
